import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, Trash2 } from 'lucide-react';

interface RecipeInput {
  itemName: string;
  quantity: number;
}

interface RecipeInputsEditorProps {
  inputs: RecipeInput[];
  onChange: (inputs: RecipeInput[]) => void;
}

export function RecipeInputsEditor({ inputs, onChange }: RecipeInputsEditorProps) {
  const addInput = () => {
    onChange([...inputs, { itemName: '', quantity: 1 }]);
  };

  const removeInput = (index: number) => {
    onChange(inputs.filter((_, i) => i !== index));
  };

  const updateInput = (index: number, field: keyof RecipeInput, value: string | number) => {
    const updated = inputs.map((input, i) => (i === index ? { ...input, [field]: value } : input));
    onChange(updated);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium">Inputs</label>
        <Button type="button" variant="outline" size="sm" onClick={addInput}>
          <Plus className="h-3 w-3 mr-1" />
          Add
        </Button>
      </div>
      {inputs.length === 0 && <p className="text-sm text-muted-foreground">No inputs defined.</p>}
      {inputs.map((input, index) => (
        <div key={index} className="flex items-center gap-2">
          <Input
            placeholder="Item name"
            value={input.itemName}
            onChange={(e) => updateInput(index, 'itemName', e.target.value)}
            className="flex-1"
          />
          <Input
            type="number"
            placeholder="Qty"
            value={input.quantity}
            onChange={(e) => updateInput(index, 'quantity', parseInt(e.target.value, 10) || 1)}
            className="w-20"
            min={1}
          />
          <Button type="button" variant="ghost" size="icon" onClick={() => removeInput(index)}>
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        </div>
      ))}
    </div>
  );
}
